import SiafLiteImpressoraApi from "../../external/siaf-lite-impressora-api";

class BalancaService {
  constructor() {}

  lerPeso() {
    return new SiafLiteImpressoraApi("/balanca/peso").get();
  }

  listarPortas() {
    return new SiafLiteImpressoraApi("/balanca/portas").get();
  }

  getConfig() {
    return new SiafLiteImpressoraApi("/balanca/config").get();
  }

  salvarConfig(body) {
    return new SiafLiteImpressoraApi("/balanca/config").post(body);
  }
}

export default BalancaService;